var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"power-ikwi-chart"},[_c('div',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"chart",staticClass:"chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }